import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import { workshopService, Workshop } from "../services/firebase";
import "./Workshops.css";
import WorkshopCard from "../components/WorkshopCard";

const Workshops: React.FC = () => {
  const { t } = useTranslation();
  const [workshops, setWorkshops] = useState<Workshop[]>([]);
  const [loading, setLoading] = useState(true);
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  //גלילה ללמעלה
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const fetchWorkshops = async () => {
      try {
        const data = await workshopService.getAll();
        setWorkshops(data as Workshop[]);
      } catch (error) {
              } finally {
        setLoading(false);
      }
    };

    fetchWorkshops();
  }, []);

  return (
    <div className="workshops-section-workshops">
      {/* <CurvedAccent className="curved-accent-workshops" /> */}
      <div className="page-workshops-container">
        <p className="section-title-workshops">{t("workshopsTitle")}</p>
        <p className="section-description-bolt-workshops">
          {t("workshopsDescriptionBolt")}
        </p>
        <p className="section-description-workshops">
          {t("workshopsDescription")}
        </p>

        <div className="workshops-grid-workshops" ref={ref}>
          {loading ? (
            <div>Loading...</div>
          ) : (
            workshops.map((workshop) => (
              <WorkshopCard
                key={workshop.id}
                workshop={workshop}
                inView={inView}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Workshops;
